import { Component } from "react";
import { connect } from "react-redux";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import {
  hideNewUserModal,
  showNewUserModal,
} from "../../redux-state/features/users";
import NewUserForm from "./newUserForm";

class NewUserModal extends Component {
  handleClose = () => {
    this.props.hideNewUserModal();
  };
  render() {
    const { show } = this.props;
    return (
      <div>
        <Modal
          show={show}
          onHide={this.handleClose}
          backdrop="static"
          keyboard={false}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: "13px" }}>
              إنشاء حساب جديد
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <NewUserForm />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleClose}>
              إلغاء العملية
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const mapDispatchToProps = { showNewUserModal, hideNewUserModal };
const mapStateToProps = (state) => ({ show: state.UsersState.showModal });
export default connect(mapStateToProps, mapDispatchToProps)(NewUserModal);
